import {
  SubcategoriesPaginated,
  SubcategoryContent,
  SubcategoryInput,
  SubcategoryItem
} from 'types/SubcategoriesTypes';
import useHttp from '../helpers/HttpMethods';

const http = useHttp();

class SubcategoriesService {
  /**
   * Busca as subcategorias paginadas.
   * @param {string} filter - Filtros em string.
   * @returns {Promise<SubcategoriesPaginated | Response>} - Subcategorias em formato paginado.
   */
  static async list(
    filter: string
  ): Promise<SubcategoriesPaginated | Response> {
    return await http.get(`/subcategories?${filter}`);
  }

  /**
   * Busca uma subcategoria por ID.
   * @param {number} id - ID da subcategoria.
   * @returns {Promise<SubcategoryItem | Response>} - Subcategoria encontrada ou resposta de erro.
   */
  static async findById(id: number): Promise<SubcategoryItem | Response> {
    return await http.get(`/subcategories/${id}`);
  }

  /**
   * Busca subcategorias por categoria.
   * @param {number} categoryId - ID da categoria.
   * @param {string} filter - Filtros em string.
   * @returns {Promise<SubcategoryItem[] | Response>} - Subcategorias da categoria.
   */
  static async listByCategory(
    categoryId: number,
    filter: string
  ): Promise<SubcategoryItem[] | Response> {
    return await http.get(`/subcategories/by-category/${categoryId}?${filter}`);
  }

  /**
   * Cria uma nova subcategoria.
   * @param {SubcategoryInput} body - Dados da subcategoria a ser criada.
   * @returns {Promise<SubcategoryContent | Response>} - Subcategoria criada ou resposta de erro.
   */
  static async create(
    body: SubcategoryInput
  ): Promise<SubcategoryContent | Response> {
    return await http.post(body, '/subcategories');
  }

  /**
   * Edita uma subcategoria existente.
   * @param {number} id - ID da subcategoria a ser atualizada.
   * @param {SubcategoryInput} body - Dados da subcategoria para atualização.
   * @returns {Promise<SubcategoryContent | Response>} - Subcategoria atualizada ou resposta de erro.
   */
  static async edit(
    id: number,
    body: SubcategoryInput
  ): Promise<SubcategoryContent | Response> {
    return await http.put(body, `/subcategories/${id}`);
  }
}

export default SubcategoriesService;
